import type { ReceptionStatus, ReceptionType, PaymentMethod, ProofType, DateType, FlowType } from '../enums/reception.enum';
import { ReceptionItemDTO } from './reception-item';
import { Search } from './search';
import type { TripCardDTO } from './trip-card';

export class ReceptionDTO {
    id?: number;

    receivedDate?: string | null;
    status: ReceptionStatus;
    type: ReceptionType;
    blacklist?: boolean;

    customerName?: string | null;
    phone1?: string | null;
    phone2?: string | null;
    phone3?: string | null;

    province?: string | null;
    city?: string | null;
    address?: string | null;

    requestNote?: string | null;
    handleNote?: string | null;
    note?: string | null;
    repairNote?: string | null;
    inboundNote?: string;
    outboundNote?: string;

    estimateDate?: string | null;
    estimateAmount: number; // 
    estimateIssueDate?: Date | null;

    repairCost: number;     // 
    tripFeeAmount: number;      // 출장비(출장자지불)
    tripFee: number;         // 출장비(고객청구)
    logisticsFee: number;
    profit: number;         // 

    paymentMethod?: PaymentMethod | null;
    proofType?: ProofType | null;
    items?: ReceptionItemDTO[];
    tripCard?: TripCardDTO | null;

    updateAdmin?: string | null;
}

/** 검색 DTO (백엔드 파라미터와 동일) */
export class ReceptionSearchDTO extends Search {
    status?: ReceptionStatus | '';
    ignoreStatus?: string | '';
    ignoreTypes?: string | '';
    types?: string | '';
    type?: ReceptionType | '';
    firstStatus?: ReceptionStatus | '';
    dateType?: DateType | '';
    flowType?: FlowType | '';
    beginEstimateAmount?: string | '';
    endEstimateAmount?: string | '';
    startManufactureMonth?: string = '';
    endManufactureMonth?: string = '';
    modelName?: string | '';
    repairNote?: string | '';
}

// 견적 통계 응답 타입 정의
export class EstimateStatsResponse {
    estimateCount: number;    // 견적건수
    estimateAmount: number;   // 견적금액
    totalProfit: number;      // 이익합계
}

// 대시보드 통계 응답 타입 정의
export class DashboardStatsResponse {
    totalSales: number;       // 총 매출
    totalCost: number;        // 총 원가
    totalProfit: number;      // 총 이익
    totalAR: number;          // 미수금
    countTotal: number;       // 총 접수 건수
    countCompleted: number;   // 완료 건수
}